// extracted by mini-css-extract-plugin
export default {"option":"SelectParticipantPopover_option__hrEgj","noStudentsInfo":"SelectParticipantPopover_noStudentsInfo__NJ6JM"};